// Pomocnicze funkcje dostępności formularza brief.

const announcer = () => document.getElementById("briefAnnounce");

// Jeden live region (aria-live=polite) dla zmian kroków, ROZSZ i uploadów.
export function announce(text) {
    const el = announcer();
    if (!el) return;
    el.textContent = "";
    // wymuszenie ponownego odczytu przy identycznym tekście
    requestAnimationFrame(() => {
        el.textContent = text;
    });
}

// Focus na nagłówku/elemencie z tabindex=-1 + dosunięcie do góry ekranu.
export function focusHeading(el) {
    if (!el) return;
    el.focus({ preventScroll: true });
    el.scrollIntoView({ block: "start", behavior: prefersReducedMotion() ? "auto" : "smooth" });
}

export function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

// Odpowiednik brief_field_id() z PHP: nazwa pola -> id slotu.
export function fieldId(name) {
    return "f-" + name.replace(/[[\]]/g, "").replace(/_/g, "-");
}
